import {useMemo} from 'react'
import {isContextDiffLine} from '../helpers/line-helpers'
import type {DiffLineWithSelectionInfo} from '../types'
import {useGetSelectedLineRange} from '../stores/selectors'

export function useCommentDialogTitle(
  diffLine: DiffLineWithSelectionInfo,
  isLeftSide: boolean,
  isLineSelected: boolean,
) {
  const getSelectedLineRange = useGetSelectedLineRange()

  return useMemo(() => {
    const selectedLineRange = isLineSelected ? getSelectedLineRange() : undefined
    let text = ''
    const isMultiLineComment: boolean =
      !!selectedLineRange && selectedLineRange.startLineNumber !== selectedLineRange.endLineNumber

    if (selectedLineRange && isMultiLineComment) {
      const lineSideIdentifier = {
        left: 'L',
        right: 'R',
      }
      const startSideIdentifier = lineSideIdentifier[selectedLineRange.startOrientation]
      const endSideIdentifier = lineSideIdentifier[selectedLineRange.endOrientation]
      const isMultiLineSelection = selectedLineRange.startLineNumber !== selectedLineRange.endLineNumber

      text += isMultiLineSelection
        ? ` lines ${startSideIdentifier}${selectedLineRange.startLineNumber} to ${endSideIdentifier}${selectedLineRange.endLineNumber}`
        : ` line ${startSideIdentifier}${selectedLineRange.startLineNumber}`
    } else {
      const sideIdentifier = isLeftSide && !isContextDiffLine(diffLine) ? 'L' : 'R'
      text += ` line ${sideIdentifier}${diffLine.blobLineNumber}`
    }

    return text
  }, [diffLine, isLeftSide, isLineSelected, getSelectedLineRange])
}
